import { Box } from "@mui/material";

function fmtMoney(n) {
  if (n == null) return "";
  return `$${Number(n).toFixed(3)}`;
}

export default function Crumbs({ trace }) {
  const total = trace?.tokens?.total ?? trace?.tokens?.sum;
  const ms = trace?.latency_ms ?? trace?.latencyMs ?? trace?.latency;
  const cost = trace?.cost;
  const label = trace
    ? `${total ?? "?"} tok · ${ms ?? "?"} ms${
        cost != null ? ` · ${fmtMoney(cost)}` : ""
      }`
    : "Ready";
  return (
    <Box
      role="status"
      aria-label="trace summary"
      tabIndex={0}
      sx={{
        display: "inline-block",
        border: "1px solid rgba(255,255,255,.24)",
        borderRadius: 999,
        px: 1.25,
        py: 0.5,
        fontSize: 12,
        opacity: 0.9,
      }}
    >
      {label}
    </Box>
  );
}
